import React from "react";
import tw, { styled } from "twin.macro";
import Carousel from "react-multi-carousel";
import CopyToClipboard from "../CopyToClipboard/CopyToClipboard";

const CarouselContentWrapper = styled.div`
	${tw`rounded-2xl p-4 flex-auto h-44 md:flex-1 flex flex-col justify-between`}
`;

const ContentWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	flex-wrap: nowrap;
	margin-bottom: 1rem;
`;

const AccountDetailsCard = ({
	virtualAccounts,
	setAccountSelected,
	accountSelected,
}) => {
	const responsive = {
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: 1,
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 1,
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1,
		},
	};

	return (
		<Carousel
			swipeable={false}
			draggable={false}
			arrows={false}
			showDots={true}
			responsive={responsive}
			ssr={true} // means to render carousel on server-side.
			infinite={true}
			autoPlay={true}
			autoPlaySpeed={5000}
			keyBoardControl={false}
			dotListClass="custom-dot"
			transitionDuration={500}
			containerClass="carousel-container">
			{virtualAccounts?.map((account, i) => {
				return (
					<CarouselContentWrapper
						key={i}
						style={{
							backgroundColor: "#F4F4F8",
						}}
						onClick={() => {
							setAccountSelected(account);
						}}>
						<ContentWrapper>
							<h5 tw="opacity-50 text-sm font-normal">
								Account number
							</h5>
							<CopyToClipboard text={account.accountNumber} />
						</ContentWrapper>
						<div>
							<h4 tw="font-bold text-base mb-0!">
								{account.accountNumber}
							</h4>
							<h4 tw="font-semibold text-sm opacity-70 mb-0!">
								{account.bankName}
							</h4>
						</div>
					</CarouselContentWrapper>
				);
			})}
		</Carousel>
	);
};

export default AccountDetailsCard;
